import i18n from "./translations.json";

declare global {
  interface Window {
    translations: typeof i18n;
  }
}

export const translations = i18n;
window.translations = i18n;
